const path = require('path')

const router = require('../../router')


module.exports = async(graphql, actions, route) => {
  const { createPage } = actions
  const gridContainer = path.resolve('src/containers/Grid/index.js')

  const looksQuery = await graphql(
    `
      query looks {
        allContentfulLook {
          edges {
            node {
              slug
            }
          }
        }
      }
    `
  )

  const slugs = looksQuery.data.allContentfulLook.edges.map((e) => e.node.slug)
  const uniqSlugs = [...new Set(slugs)]

  uniqSlugs.forEach(async(lookSlug) => {
    if (!lookSlug) {
      throw new Error('Null Param')
    } else {
      await createPage({
        path: router(route.path, {
          slug: lookSlug,
        }),
        component: gridContainer,
        context: {
          lookSlug,
          isVip: !!route.isVip,
        },
      })
    }
  })
}
